import { Injectable } from '@angular/core';
import { NavigationError, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ChunkRecoveryService {
  private static readonly KEY = 'vitay_recovery_reload';
  private static readonly MAX = 2;
  private static readonly PATTERN =
    /Failed to fetch dynamically imported module|Loading chunk \d+ failed|chunk-loading-failed|Importing a module script failed/i;

  constructor(private readonly _router: Router) {
    this._router.events
      .pipe(filter((e): e is NavigationError => e instanceof NavigationError))
      .subscribe((e) => this.maybeRecover(e));
  }

  public maybeRecover(event: NavigationError): boolean {
    const err: any = event && event.error;
    const msg: string = (err && err.message) || String(err || '');
    if (!ChunkRecoveryService.PATTERN.test(msg)) return false;

    const count = this.getCount();
    if (count >= ChunkRecoveryService.MAX) {
      try {
        console.error('[vitay] Chunk recovery exhausted:', msg);
      } catch (e) { /* noop */ }
      return false;
    }
    this.bumpCount();
    const sep = window.location.search ? '&' : '?';
    this.reload(
      window.location.pathname +
        window.location.search +
        sep +
        '_recovery=' +
        Date.now() +
        window.location.hash
    );
    return true;
  }

  // Seam for specs: window.location.replace is non-writable in Chrome, so it
  // can't be spied on directly
  public reload(url: string): void {
    window.location.replace(url);
  }

  private getCount(): number {
    try {
      return parseInt(sessionStorage.getItem(ChunkRecoveryService.KEY) || '0', 10);
    } catch (e) {
      return 0;
    }
  }

  private bumpCount(): void {
    try {
      sessionStorage.setItem(ChunkRecoveryService.KEY, String(this.getCount() + 1));
    } catch (e) { /* noop */ }
  }
}
